import GraficaBarras from './GraficaBarras';
export default GraficaBarras;